import { useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { MAX_INPUT_LENGTH_2048 } from '../../../../../../../../constants';
import styles from './DiagnosisBlock.module.scss';
import { Button, Textarea } from 'components';
import { appActions } from 'store/app/slice';
import { patientsActions } from 'store/patients/slice';
import { useDispatch } from 'store/utils';
import { onlyLatinLettersSymbolsNumbers } from 'utils';

type Props = {
  id: number;
  diagnosis: string;
  treatmentPlan: string;
  onClose(): void;
};

const schema = yup.object({
  diagnosis: yup
    .string()
    .matches(onlyLatinLettersSymbolsNumbers, {
      message: 'Only Latin Alphabet is allowed',
    })
    .required('The field is empty'),
});

export const DiagnosisBlock = ({ diagnosis, treatmentPlan, id, onClose }: Props) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      diagnosis: diagnosis ?? '',
    },
  });

  const watchedDiagnosis = watch('diagnosis');

  useEffect(() => {
    dispatch(patientsActions.setShouldPatientPageUpdate(false));
    dispatch(patientsActions.setIsPatientPageEdited(true));
    return () => {
      dispatch(patientsActions.setShouldPatientPageUpdate(true));
      dispatch(patientsActions.setIsPatientPageEdited(false));
    };
  }, []);

  const onSubmit = handleSubmit(async (formData) => {
    try {
      const wrappedResult = dispatch(
        patientsActions.updatePatientDiagnosisAndTreatment({
          patientCaseData: {
            diagnosis: formData.diagnosis,
            treatmentPlan: treatmentPlan ?? null,
          },
          patientCaseId: id,
        }),
      );
      await wrappedResult.unwrap();

      onClose();
      dispatch(appActions.setModalErrorText({ name: 'treatmentAndDiagnosisError', errorText: '' }));
    } catch (error: any) {
      dispatch(appActions.setModalErrorText({ name: 'treatmentAndDiagnosisError', errorText: error?.title }));
      dispatch(appActions.setIsModalOpened({ isOpened: true, name: 'treatmentAndDiagnosisError' }));
      onClose();
    }
  });
  return (
    <form className={styles.inputItem}>
      <Textarea
        labelText=""
        placeholder="Please fill in the diagnosis"
        inputName="diagnosis"
        register={register}
        maxLength={MAX_INPUT_LENGTH_2048}
        autoComplete="off"
        characterCounter
        errorMsg={errors.diagnosis?.message as string}
        currentValue={watchedDiagnosis}
        setValue={setValue}
        isForLinks={false}
      />
      <div className={styles.buttonRow}>
        <Button onClick={onClose}>Cancel</Button>
        <Button className={styles.submitButton} onClick={onSubmit}>
          Save
        </Button>
      </div>
    </form>
  );
};
